import useSeo from "../../hooks/useSeo";
import Hero from "./components/Hero";
import TopWorks from "./components/TopWorks";
import Categories from "./components/Categories";
import LatestUpdates from "./components/LatestUpdates";
import Community from "./components/Community";
import Reputation from "./components/Reputation";
import FaqTeaser from "./components/FaqTeaser";
import Cta from "./components/Cta";

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "如何找到某类特定的同人作品？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "进入「作品库」页面，可以使用主题分类进行筛选，例如长篇连载、热血战斗、清水治愈、穿越重生等；也可以搜索作品名、角色或标签关键词快速定位。",
      },
    },
    {
      "@type": "Question",
      name: "作品库多久更新一次？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "我们每天都会跟进社区最新动态，热门作品与合集会在数小时至一天内入库更新，每部作品的最近更新时间会如实标注。",
      },
    },
  ],
};

export default function Home() {
  useSeo({
    title: "火影忍者同人作品合集、社区推荐与导航目录 - 忍界同人志",
    description:
      "忍界同人志聚合火影忍者同人作品、合集与社区导航，按目录整理热门推荐，从经典长篇到冷门短篇持续更新，一站式追更同人不迷路。",
    jsonLd: faqJsonLd,
  });

  return (
    <>
      <Hero />
      <TopWorks />
      <Categories />
      <LatestUpdates />
      <Community />
      <Reputation />
      <FaqTeaser />
      <Cta />
    </>
  );
}